import {
  appEnvironment,
  appEnvironmentWorkstations,
} from '@qaroni-env/environment';

export const AppConfig = {
  name: 'Workards',
  version: appEnvironment.currentVersion,
};

export const AppEnv = {
  appCode: Object.prototype.hasOwnProperty.call(appEnvironment, 'appCode')
    ? appEnvironment.appCode
    : null,
};

export const AppEnvWorkstations = {
  appCode: Object.prototype.hasOwnProperty.call(
    appEnvironmentWorkstations,
    'appCode'
  )
    ? appEnvironmentWorkstations.appCode
    : null,
};
